import React from 'react';

import classNames from 'classnames';

import { statusPONR, statuses, statusesText } from './constants';

import styles from './styles.module.scss';

export const AppointmentStatusInfo: React.FC<sharedComponents.StatusInfo> = ({
  status,
  aqaId,
  className,
  statusText,
  isStatusPONR,
}) => (
  <span id={aqaId} className={classNames(styles.status, styles[statuses[status]], className)}>
    {isStatusPONR ? statusPONR : statusesText[status] || statusText}
  </span>
);
